export const isCountrySupported = (userCountry, countries) => {
  return countries.some(
    (country) =>
      country.alpha2 === userCountry.toLowerCase() && country.activated_at
  );
};
